import { COVERT_EN_US } from "#pages/place/settings/couvert/translations";
import { vendor } from "./vendor";

export const settings = {
	title: "Edit settings",
	error: "No permission to edit place",
	alterImage: "Image changed successfully",
	attention: "Attention!",
	url: "productname",
	daysAndWorkingPeriod: "Days and working hours",
	address: {
		postalCode: "Postal Code",
		state: "State",
		city: "City",
		neighborhood: "Neighborhood",
		address: "Street",
		number: "Number",
		complement: "Complement",
		placeholders: {
			state: "e.g. SP",
			city: "e.g. São Paulo",
			neighborhood: "e.g. Downtown",
			address: "e.g. Av. Paulista",
			number: "e.g. 60",
			complement: "e.g. Suite A",
		},
	},
	workingPeriod: {
		deletedPeriod: "Period deleted.",
		addDaysAndTime: "Add days and times",
		addOpeningHours: "Add opening hours",
		daysOfTheWeek: "Days of the week",
		start: "Start",
		end: "End",
	},
	menu: {
		title: "Other configuration options",
		general: {
			title: "General",
			subtitle: "Inform limits, e-mails and others",
		},
		productsWeb: {
			title: "Web Products",
			subtitle: "Configure the bar linking for delivery.",
		},
		record: {
			title: "Record",
			subtitle: "Configure token mode",
		},
		couvert: {
			title: "Couvert",
			subtitle: "Set the cover charge",
		},
		features: {
			title: "Features",
			subtitle: "Enable desired features",
		},
		pdv: {
			title: "PDV",
			subtitle: "Configure the point of sale",
		},
		totem: {
			title: "Totem",
			subtitle: "Customize a totem",
		},
		refundReason: {
			title: "Refund/Cancel Reasons",
			subtitle: "Configure reasons for the point of sale",
		},
		vendor: {
			title: "Vendor",
			subtitle: "Configure general information",
		},
		fiscalPrinter: {
			title: "Fiscal Printers",
			subtitle: "Configure the fiscal printers",
		},
		deliveryFees: {
			title: "Delivery fees",
			subtitle: "Link delivery fees to fiscal groups",
		},
	},
	productsWeb: {
		title: "Web Products",
		subtitle: "Configure the link and other information for delivery and table ordering.",
		saveChanges: "Save changes",
		toastSuccess: "Settings saved successfully",
		toastError: "Could not save settings. Please try again.",
		tabMenuPersonalization: "Menu personalization",
		tabFichaDigital: "Ficha Digital",
		tabs: {
			barLink: "Bar linking",
			deliveryFee: "Delivery fees",
		},
		fichaDigital: {
			heading: "Event display on the menu",
			subtitle: "Which events should appear on this menu?",
			sameDayLabel: "Show only events from this day",
			sameDayDescription: "Displays only the events that happen on the menu's date.",
			samePlaceLabel: "Show all events from this place",
			samePlaceDescription:
				"Also displays events from other dates linked to the same place.",
			save: "Save Changes",
			saving: "Saving...",
			toastSuccess: "Configuration saved successfully",
			toastError: "Could not save the configuration",
		},
		generalTab: {
			urlLabel: "URL Address",
			urlSubtitle:
				"Set the access URL for Digital Menu, Delivery, Table Order and Online Tab.",
			slugInvalid: "Slug must contain only letters, numbers, hyphens and underscores",
			barLabel: "Bar linking",
			barSubtitle:
				"Define which bar the menus created through delivery integration will be linked to.",
			selectBarLabel: "Select a bar",
			selectBarTooltip: "Only one bar can be linked to menus created from integrations",
			save: "Save Changes",
		},
		deliveryFee: {
			title: "Delivery fees",
			subtitle: "Define how the delivery fee will be charged on delivery orders.",
			taxTypeLabel: "Charge type",
			taxTypeOptions: {
				unique: "Flat fee",
				baseRateWithVariableKm: "Base fee + price per Km",
				ratePerRadius: "Price per service radius",
			},
			baseRateValueLabel: "Base fee",
			ratePerKmLabel: "Price per Km",
			attendanceRadiusLabel: "Service radius",
			attendanceRadiusSuffix: "km",
			save: "Save Changes",
		},
	},
	warningDialog:
		"You are enabling postpaid payments on '{{name}}'. Are you sure about this? To confirm the modification, please type '{{text}}'",
	data: {
		label: "Data",
		name: "Name",
		selectProduct: "Select a product to enable automatic security deposit",
		noneProduct: "No products",
		peopleCapacity: "Maximum capacity",
		slug: "Slug",
		peopleCapacityTooltip: "Number of people the place holds",
	},
	passTemplate: "ID do modelo do passe",
	limits: {
		label: "Limits and services",
		postPaidLimit: "Postpaid limit",
		serviceTax: "Service charge",
		rechargeNotIntegratedLimit: "Non-integrated recharge limit",
		nonIntegratedPaymentLimit: "Non-integrated payment limit per device and event",
		enableBuiltInLimit: "Enable non-integrated recharge limit",
		enableNonIntegratedPaymentLimit:
			"Enable non-integrated payment limit per device and event",
		nonIntegratedPaymentLimitTooltip:
			"This limit refers to the maximum amount of non-integrated payments that a device can receive during the event. This parameter is the sum of total Recharges and Sales without a Card made with non-integrated payments",
		nonIntegratedRechargeLimitTooltip:
			"This limit refers to the maximum amount that an employee can make in a non-integrated recharge",
	},
	settings: {
		label: "Settings",
		myActionsPassword: {
			label: "¨My Actions¨ password",
			placeholder: "Enter a numeric password or the default password will be 9090",
		},
		sellVisualizationFormat: {
			label: "Display format of products on sale",
			grid: "Grid",
			list: "List",
		},
		kdsServer: {
			label: "KDS server IP",
			placeholder: "Enter the IP",
		},
	},
	everest: {
		label: "Everest",
		user: "User",
		password: "Password",
		cnpj: "CNPJ",
		host: "Host",
	},
	placeFeatures: "Functionalities",
	email: "Emails to receive closing events",
	emailError: "Invalid email",
	consumption: {
		label: "Minimum consumption tax setup",
		fiscalProfile: "Fiscal profile",
		fiscalGroup: "Fiscal group",
		ncm: "NCM",
	},
	alert: "Modifications have been made, save to keep them",
	save: "Save",
	image: "Image",
	ficha: {
		label: "Ficha",
		text: "Title of the Form",
		placeholderText: "Insert the form title",
		logo: "Image in the form",
		upload: "Attach image",
		formatError: "Unsupported format",
		imageFormatMessage: "The image must be in PNG or SVG format.",
		recommendationMessage:
			"We recommend that the assigned image be the <strong>company logo</strong> in <strong>black color</strong>, as it is not possible to print in another color.",
		dragOrSelectMessage:
			"Drag the image from your computer or select it from 'Attach image'.",
		logoFormatMessage:
			"The <strong>background of the image/logo must be white</strong> to appear transparent in printing.",
		dimensionsMessage:
			"The suggested dimensions for good resolution are <strong>472x472</strong> px.",
		size: {
			Small: "S - Small",
			Medium: "M - Medium",
			Large: "L - Large",
			NoImage: "No Image",
			NoQRCode: "No QRCode",
			recommend: "recommended",
		},
		fontSize: "Font size",
		imageSize: "Image",
		qrCodeSize: "QR Code size",
	},
	couvertEdit: COVERT_EN_US,
	devices: {
		label: "Place PDVs ({{counter}})",
		placeholder: "Add a PDV to this location",
		requestDevices: "Request devices",
	},
	errors: {
		invalidName: "Please enter a valid name",
		invalidTip: "Enter a value of up to 25%",
		postPaidLimit: "Please enter a valid value",
		rechargeNotIntegratedLimit: "Minimum value of",
		hasConsumptionObligation: "Mandatory field for consumption obligation configuration",
		minNonIntegratedPaymentLimit: "Minimum value of {{value}}",
		tipOptionsValuesRequired: "Tip values are required",
		tipOptionLowerValue:
			'The "Lower Value" must be less than the Medium and Higher values',
		tipOptionHigherValue: 'The "Higher Value" must be greater than the Medium value',
		invalidUrl: "Enter a valid URL (https://...)",
		invalidCep: "Invalid postal code. Enter 8 digits.",
		requiredAddressField: "Required when the address is being filled",
		cepLookupFailed: "Could not look up the postal code. Please fill it in manually.",
	},
	totem: {
		logoSelectDescription:
			"<strong>Select the logo that best fits your image</strong> (disregard the background color)",
		addLogo: "Add",
		important: "Important",
		instructions: "Recommendations",
		image:
			"The image should have dimensions of <strong>1080 x 1920</strong> px in height",
		logo:
			"The <strong>Zig</strong> logo will appear over the assigned image, centered at the top.",
		recommendations:
			"It is recommended to insert the message <strong>'tap to start'</strong> to guide the user",
		defaultMessage:
			"If you don't add a cover image, " +
			"Zig's default screen will be your home screen " +
			"(see the first image under <strong>'Colors'</strong>.)",
		totemImgLabel: "Home screen image (optional)",
		totenCustomizationLabel: "Totem Cover Customization",
		removeTotemImage: {
			title: "Do you want to delete the home screen?",
			content: "By deleting it, the home screen will revert to Zig's default screen.",
			confirmBtn: "Yes, I want to delete",
			cancelBtn: "No",
		},
		colors: "Colors",
		saveMessage: "Save customization",
	},
	tip: {
		taxType: "Tax Type",
		tipSuggestions: "Tip Suggestions",
		tip: "Tip",
		serviceTax: "Service Charge",
		none: "None",
		lowerValue: "Lower Value",
		medValue: "Medium Value",
		higherValue: "Higher Value",
		tooltip:
			"Tip recommendations make paying the bill easier by offering three percentage options (Smaller, Medium, and Larger) based on the total amount of the bill, for example: 5%, 10%, and 15%, capped at 25%.",
	},
	authKeysFeature: {
		phone: "Phone",
		email: "Email",
		keySelectLabel: "Choose the key type",
		addKey: "Add Authentication Keys",
		contactsInputLabel: "Add one or more keys for authentication",
		contactsEmailInputPlaceholder: "Enter a valid email (e.g: emailname@gmail.com)",
		contactsPhoneInputPlaceholder: "Enter a phone number (e.g: +55 (00) 0 00000000",
		btnAddKey: "Add authentication keys",
		btnCancelAddKey: "Cancel",
		authKeyAreaTitle: "Withdrawal authentication",
		authKeyAreaSubtitle:
			"Register keys (email or phone) that will be used to receive the authentication code when requesting a withdrawal.",
		selectContactKeyMessage: "Select a key type",
		selectContactInputMessage: "Fill in a contact key",
		contactAlreadyExists: "This contact already exists!",
		invalidEmail: "Invalid email",
		invalidPhone: "Invalid phone. Must contain DDI (e.g: +5511999999999)",
		incompletePhone: "Incomplete phone number. Enter all digits.",
		invalidDDI:
			"Only Brazilian phone numbers are accepted. Use DDI +55 or leave it blank.",
		errorCreatingAuthKeys: "Error creating authentication keys",
		invalidContactsFound: "Invalid contacts found. Check the data and try again.",
		errorCreatingSomeKeys: "Error creating some keys: {{errors}}",
	},
	vendor,
	invoiceMoment: {
		fieldLabel: "Select the moment for cashless invoice issuance",
		tip:
			"Select the timing of the invoice issuance for Cashless payments. For all other payment methods that are not Cashless, the invoice will always be issued upon consumption",
		recharge: "Recharge",
		rechargeAndActivation: "Recharge and activation",
		consumption: "Consumption",
		consumptionAndActivation: "Consumption and activation",
	},
	refundReason: {
		addReason: "Create new reason",
		cancel: "Cancellation",
		modalDelete: {
			confirmation:
				"Do you want to remove the reason from the list of refund and cancellation reasons?",
			description:
				"By removing the reason, it will no longer appear, but it will remain in old reports.",
			title: "Remove reason",
		},
		modalForm: {
			addReason: "Create Reason",
			allowOpenText: "Enable justification",
			creatingReason: "Creating a reason",
			editReason: "Save changes",
			editingReason: "Editing a reason",
			reason: "Reason name",
			reasonPlaceholder: "Enter the name for the refund and/or cancellation reason",
		},
		reason: "Reason name",
		removeReason: "Edit reason",
		refund: "Refund",
		table: {
			editReason: "Edit reason",
			observation: "Observation",
			reason: "Reason name",
			removeReason: "Remove reason",
			status: "Status",
			type: "Type",
		},
		title: "Refund and Cancellation Reasons",
	},
	fiscalPrinter: {
		title: "Fiscal Printers",
		name: "Name",
		type: "Type",
		ip: "IP",
		actions: "Actions",
		deletedSuccessfully: "Printer deleted successfully",
		addedSuccessfully: "Printer added successfully",
	},
	deliveryFees: {
		title: "Delivery fees",
		description:
			"Link each delivery fee to a fiscal group to define its treatment on invoice issuance.",
		selectPlaceholder: "Select a fiscal group",
		emptyState: "No delivery fees available.",
		saveSuccess: "Fiscal binding saved successfully.",
		removeSuccess: "Fiscal binding removed successfully.",
		invoice: {
			included: "Included in invoice",
			excluded: "Excluded from invoice",
		},
		columns: {
			name: "Fee",
			description: "Description",
			issueInvoice: "Issuance",
			fiscalGroup: "Fiscal group",
		},
		feeNames: {
			serviceFee: "Service fee",
			minimumOrderFee: "Minimum order fee",
		},
	},
	defaultDateFilter: "Default date filter",
	pageHeader: {
		title: "General settings",
		description:
			"Add information about your establishment that will be shown to end customers",
	},
	sections: {
		comingSoon: "Coming soon",
		brand: {
			title: "Brand information",
			description:
				"Add brand information such as logo, name, and slug (URL link). This information will be public and displayed on the digital menus.",
			addPhoto: "Add photo",
			fileHint: "PNG or JPEG file type.",
		},
		payments: {
			title: "Payments and Fees",
			description: "Set payment limits, tip rates, and other configurations.",
		},
		socialMedia: {
			title: "Social Networks",
			description:
				"We will display your social networks in the establishment information on the digital menus.",
			titleTooltip: "Copy and paste the establishment's social networks link",
			facebookLabel: "Facebook",
			instagramLabel: "Instagram",
			linkPlaceholder: "Paste the establishment profile link",
		},
		workingHours: {
			title: "Operating hours",
			description:
				"The establishment's operating days and hours will be shown on the digital menu when defined.",
		},
		event: {
			title: "Event information",
			description:
				"Provide the establishment's contact email, phone number, and maximum capacity.",
			emailLabel: "Emails to receive event closing reports",
		},
		address: {
			title: "Establishment address",
			description:
				"Define the establishment's address — it will be shown in the establishment information on the digital menus.",
		},
	},
};
